import { useEffect, useRef } from "react";
import { useDownloadOptions } from "../../../../hooks/useDownloadOptions";
import LifeCareDropDown from "./LifeCareDropDown";
import DownloadOption from "./DownloadOption";
import XButton from "../../../../components/common/XButton";

const versionSelectWrapperClasses = "mb-2 mt-0.5";

const optionBoxClasses =
    "absolute z-[9999999] left-[51%] bg-surface w-90 opacity-100 " +
    "rounded-sm px-6 pt-3 pb-6 gap-2 shadow-[0px_1px_4px_0px_#00000040]";

const optionListClasses = "pt-1 cursor-pointer";

const DownloadOptions = ({
    caseData,
    onClose,
    onDownloadComplete,
    onOpenVersionHistory
}) => {
    const menuRef = useRef(null);
    const { buildDownloadOptions } = useDownloadOptions(caseData);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                onClose();
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [onClose]);

    const { staticOptions, demandOptions } = buildDownloadOptions({
        onClose,
        onDownloadComplete,
    });

    const lastStaticIndex = staticOptions.length - 1;

    return (
        <div ref={menuRef} className={optionBoxClasses}>
            <div className={optionListClasses}>
                <div className={`${versionSelectWrapperClasses}`}>
                    <XButton
                        variant="outline"
                        size="sm"
                        className="w-full!"
                        onClick={onOpenVersionHistory}
                    >
                        <i className="fa fa-history mr-1!" aria-hidden="true" />
                        Version History
                    </XButton>
                </div>
            </div>

            {staticOptions.length > 0 && (
                <div className={optionListClasses}>
                    {staticOptions.map((option, index) => (
                        <DownloadOption
                            key={option.key}
                            label={option.label}
                            onClick={option.onClick}
                            isLast={index === lastStaticIndex}
                        />
                    ))}
                    <hr className="mt-0! mb-0!" />
                    <div className="mt-2 mb-2 font-bold">Demands</div>
                </div>
            )}

            {demandOptions.map((option) => (
                <div className={optionListClasses} key={option.key}>
                    {option.kind === 'lifecare' ? (
                        <LifeCareDropDown caseData={caseData} onClose={onClose} />
                    ) : (
                        <DownloadOption label={option.label} onClick={option.onClick} />
                    )}
                </div>
            ))}
        </div>
    );
};

export default DownloadOptions;
